import { Component, Input } from "@angular/core";

@Component({
  selector: "sv-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
})
export class IconComponent {
  @Input() iconClass: string = "";
  @Input() size: "sm" | "md" | "lg" = "md";
  @Input() containerClass: string = "";
  @Input() noContainer: boolean = false;
}
